document.addEventListener('DOMContentLoaded', function(){
  const swipers = document.querySelectorAll('.media__swiper');
  for (let i = 1; i <= swipers.length; i++){
    let swiperMedia = new Swiper(`.media__swiper--${i}`, {
      slidesPerView: 3,
      spaceBetween: 40,
      navigation: {
        nextEl: `.media__next--${i}`,
        prevEl: `.media__prev--${i}`,
      },
      breakpoints : {
        375: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        }
      }
    });
  }
  
  const wrapper = document.querySelector('.new-blog')
  const container = document.querySelector('.new-blog__wrapper');
  const articles = document.querySelectorAll('.new-blog__content');
  const changeContents = document.querySelectorAll('.new-blog__media');

  let activeIndex = 0;
  const dataAction = wrapper.dataset.action
  switch (dataAction) {
    case 'mouse-actions':
      handleMouseActions()
      break;
    case 'scroll':
      initBlogInteractionsByBreakpoint()
      break;
    default:
      throw new Error('Something went wrong');
  }

  function handleMouseActions() {
    container.addEventListener('click', function (event) {
      const targetArticle = event.target.closest('.new-blog__content');
      if (targetArticle) {
        const index = parseInt(targetArticle.getAttribute('data-index'));
        if (index) {
          activeIndex = index;
          activateElements(activeIndex);
        }
      }
    });

    container.addEventListener('mouseover', function (event) {
      const targetArticle = event.target.closest('.new-blog__content');
      if (targetArticle) {
        const index = parseInt(targetArticle.getAttribute('data-index'));
        if (index && index !== activeIndex) {
          activeIndex = index;
          activateElements(activeIndex);
        }
      }
    });
  }

  function initBlogInteractionsByBreakpoint() {
    const viewportWidth = window.innerWidth;

    if (viewportWidth >= 768) {
      handleScrollAction();
    } else {
      handleMouseActions();
    }
  }
  
  function handleScrollAction() {
    const contentBlocks = document.querySelectorAll('.new-blog__content');
    const mediaBlocks = document.querySelectorAll('.new-blog__media');
    let lastActiveIndex = null;
    const OFFSET = 200;

    if (!contentBlocks.length || !mediaBlocks.length) return;

    const lastContentBlock = contentBlocks[mediaBlocks.length - 1];
    if (lastContentBlock) {
      const lastHeight = lastContentBlock.getBoundingClientRect().height;
      const viewportHeight = window.innerHeight;
      const pseudoPadding = viewportHeight - lastHeight - 60;
      document.documentElement.style.setProperty('--pseudo-padding', `${pseudoPadding}px`);
    }

    const observer = new IntersectionObserver(() => {
      if (!contentBlocks.length) return;

      const activeBlock = [...contentBlocks].reduce((closest, block) => {
        const rect = block.getBoundingClientRect();
        const blockCenter = rect.top + rect.height / 2;
        const distance = Math.abs(blockCenter - OFFSET);

        if (!closest) return { block, distance };
        return distance < closest.distance ? { block, distance } : closest;
      }, null).block;

      const index = activeBlock.dataset.index;

      if (index !== lastActiveIndex) {
        contentBlocks.forEach(b => b.classList.remove('active'));
        activeBlock.classList.add('active');

        mediaBlocks.forEach(m => m.classList.remove('active'));
        const activeMedia = [...mediaBlocks].find(m => m.dataset.index === index);
        if (activeMedia) activeMedia.classList.add('active');

        lastActiveIndex = index;
      }

    }, {
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    contentBlocks.forEach(block => observer.observe(block));
  }

  function activateElements(index) {
    deactivateElements();

    const currentArticle = document.querySelector(`.new-blog__content[data-index="${index}"]`);
    const currentContent = document.querySelector(`.new-blog__media[data-index="${index}"]`);
    
    if (currentArticle && currentContent) {
      currentArticle.classList.add('active');
      currentContent.classList.add('active');

      if (window.innerWidth < 768) {
        console.log('sadasdad');
        window.scrollTo({
          top: currentContent.offsetTop - 10,
          behavior: 'smooth'
        });
      }
    }
  }

  function deactivateElements() {
    articles.forEach(article => article.classList.remove('active'));
    changeContents.forEach(
      content => {
        content.classList.remove('active');
        const video = content.querySelector('.new-blog__video');
        
        if(video) {
          if(video.querySelector('video')) {
            video.querySelector('video').pause();
          }
         
        }
        
      }
    );
  }
  
  ///video 

  const videos = document.querySelectorAll('.new-blog__video');
  
  videos.forEach(video => {
    const currentImage = video.previousElementSibling;
    currentImage.addEventListener('click', function(e){
      e.preventDefault();
      const heightImage = currentImage.offsetHeight - parseInt(window.getComputedStyle(currentImage).paddingBottom);
      const currentVideo = video.querySelector('video');
      video.classList.toggle('active');
      video.previousElementSibling.classList.add('hidden');
      currentVideo.style.display = 'block';
      currentVideo.style.height = `${heightImage}px`
      currentVideo.play();
      
    });
  })
})


